/**
 * Checks whether a value is included in a readonly literal array
 * and narrows its type to the array's union type.
 */
export function isOneOf<T extends readonly string[]>(
  arr: T,
  value: string
): value is T[number] {
  return (arr as readonly string[]).includes(value);
}
